import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, LockIcon } from 'lucide-react';
import { usd } from '../utils/format';
interface RunSummaryProps {
  periodLabel: string;
  tierBasisLabel: string;
  payoutTotal: number;
  loanCount: number;
  peopleCount: number;
}
export function RunSummary({
  periodLabel,
  tierBasisLabel,
  payoutTotal,
  loanCount,
  peopleCount
}: RunSummaryProps) {
  return <header className="border-b border-line bg-navy" data-id="element-103" data-mp="c7y3szdity8s">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-6 px-6 py-7 lg:flex-row lg:items-end lg:justify-between" data-id="element-104" data-mp="caj7ltxdqo96">
        <div data-id="element-105" data-mp="3g4jd1uvg3dx">
          <div className="flex items-center gap-2" data-id="element-106" data-mp="3gecgyb7qqnu">
            <button type="button" aria-label="Previous month" className="rounded-sm border border-white/20 p-1 text-white/70 transition-colors duration-150 ease-out hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-orange" data-id="element-107" data-mp="3fw4x5j3oq0m">
              <ChevronLeftIcon className="h-4 w-4" data-id="element-108" data-mp="zzvayd61023k" />
            </button>
            <span className="text-sm font-semibold text-white" data-id="element-109" data-mp="1oz7xbboyjk2a">{periodLabel}</span>
            <button type="button" aria-label="Next month" className="rounded-sm border border-white/20 p-1 text-white/70 transition-colors duration-150 ease-out hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-orange" data-id="element-110" data-mp="1k16bwk4278nn">
              <ChevronRightIcon className="h-4 w-4" data-id="element-111" data-mp="27nmp4173n245" />
            </button>
            <span className="ml-1 text-xs text-white/50" data-id="element-112" data-mp="23n2p8pv55keb">
              Tiers set by {tierBasisLabel}
            </span>
          </div>

          <h1 className="mt-4 text-xs font-semibold uppercase tracking-[0.14em] text-orange" data-id="element-113" data-mp="2hl9ghn5l4m50">
            Commissions payable
          </h1>
          <p className="mt-1.5 text-[44px] font-semibold leading-none tracking-tight text-white tabular-nums" data-id="element-114" data-mp="n8t21z2my1p2">
            {usd(payoutTotal)}
          </p>
        </div>

        <div className="flex flex-wrap items-end gap-x-10 gap-y-4" data-id="element-115" data-mp="2icr3dfb0hzrd">
          <Metric label="People paid" value={String(peopleCount)} data-id="element-116" data-mp="2ielp2vu3xvwi" />
          <Metric label="Files closed" value={String(loanCount)} data-id="element-117" data-mp="2ncvlf9rkj2jp" />
          <button type="button" className="inline-flex items-center gap-2 rounded-sm bg-orange px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-orange-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-orange focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-118" data-mp="2rdp8k0x6sdbj">
            <LockIcon className="h-4 w-4" data-id="element-119" data-mp="368vgwujr8o81" />
            Lock &amp; export run
          </button>
        </div>
      </div>
    </header>;
}
function Metric({
  label,
  value,
  tone = 'default'
}: {
  label: string;
  value: string;
  tone?: 'default' | 'warn';
}) {
  return <div data-id="element-120" data-mp="3k3fp0gmajrat">
      <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-white/55" data-id="element-121" data-mp="3k3o1w8ieywm0">
        {label}
      </p>
      <p className={`mt-1 font-mono text-xl font-medium tabular-nums ${tone === 'warn' ? 'text-orange' : 'text-white'}`} data-id="element-122" data-mp="3p1haf876w2pg">
        {value}
      </p>
    </div>;
}